import React from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Divider, Popover } from '@mui/material';

import { MenuItem } from 'containers/Dashboard/components/SideBar/components/FolderTreeItem/styles';

import { OrgUnit } from '../types';

import { DangerMenuItem, RowMenuButton } from './styles';

export interface UnitRowMenuProps {
  unit: OrgUnit;
  onAddUnder: () => void;
  onEdit: () => void;
  onMove: () => void;
  onDelete: () => void;
}

/** The top unit cannot move or be deleted, and Intake cannot be renamed, moved or deleted, so their items are absent. */
const UnitRowMenu: React.FunctionComponent<UnitRowMenuProps> = ({ unit, onAddUnder, onEdit, onMove, onDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  // Every unit carries a kind; only the root and Intake are the system ones.
  const isSystem = unit.kind !== 'ordinary';

  const choose = (run: () => void) => (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
    run();
  };

  return (
    <>
      <RowMenuButton
        className="row-menu"
        size="small"
        aria-label={`More actions for ${unit.name}`}
        data-testid={`unit-row-menu-${unit.uuid}`}
        aria-haspopup="menu"
        aria-expanded={anchorEl ? 'true' : 'false'}
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon fontSize="small" />
      </RowMenuButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {unit.kind === 'intake' ? null : <MenuItem onClick={choose(onAddUnder)}>Add unit under</MenuItem>}
        {unit.kind === 'intake' ? null : <MenuItem onClick={choose(onEdit)}>Rename</MenuItem>}
        {isSystem ? null : <MenuItem onClick={choose(onMove)}>Move</MenuItem>}
        {isSystem ? null : <Divider />}
        {isSystem ? null : <DangerMenuItem onClick={choose(onDelete)}>Delete</DangerMenuItem>}
      </Popover>
    </>
  );
};

export default UnitRowMenu;
